import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
              <p className="card__price">{todo.pris}</p><span className="card__ordPrice">{todo.ordpris}</span>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.recUrl} className="card__link">Läs recension</a>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos, setTodos] = useState([
        {
            img: '/vitatander-simplesmile.jpg',
            pris: '399:-',
            ordpris: '',
            prodnamn: 'Tandblekningspenna',
            text: 'Blekgelen penslas på tänderna.',
            recUrl: '/confidentsmile',
            buttonUrl: 'https://www.lyko.se/skonhetsapotek/munhygien/tandblekning/confidentsmile-tandblekningspenna?utm_source=Vita+t%C3%A4nder&utm_medium=affiliate&utm_campaign=adtraction&utm_content=1117786221&at_gd=25A43DA673616BC548A84C3E6B5279CCBD5A1C2A'
        },
        {
            img: '/vitatander-whiteone.jpg',
            pris: '349:-',
            ordpris: '',
            prodnamn: 'Tandblekningspenna',
            text: 'Bästsäljare och är extra effektiv.',
            recUrl: '/whiteone',
            buttonUrl: 'https://www.whiteone.com/product/tandblekningspenna?tduid=a4eef33abb44feb1843ece232730058d'
        },
        {
            img: '/vitatander-denta-penna.jpg',
            pris: '399:-',
            ordpris: '',
            prodnamn: 'Tandblekningspenna',
            text: 'Lätt att komma åt på svåra ställen.',
            recUrl: '/dentaworks',
            buttonUrl: 'https://track.adtraction.com/t/t?a=25976272&as=1480987224&t=2&tk=1&url=https://www.tandblekning.com/tandblekningspenna'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;